// DS: i9.11
import React from 'react';
import IconWrap from '../../IconWrap';
const DollarHeart = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("image", {
        width: "16",
        height: "16",
        xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEbSURBVHgB5Zc9CsIwGIajuDl4AwenTk7iBVxdvEInTyC4OLgInsCpV3DQU4iTU0ER6g0cXESoEHxrk+ZLkzo0wWdpS76Qvk9+Shn7dxol7allP9t61mQ1o01yuu+Vjf3OWO5vW5/hnAFtEhkkk+uP7aWyPmwdCuM6Y4Anj15DZdHgsWAmUMnB7jLi122wysav3UDLpEhOBiNYA5Q5EN/Cz11SaPPDgExuX3OwumUT3+Q0bhnAGwfdyKQvOfdy8vMzYRRunoSz64Y/UCZyJ5oA+gE5eX7/48btr2GZCQAjqDdJDpw1AAQTYN2bKosn8Vx41iUHzhsAWhNVkgNvDADBhM1qp/DOAOAmMPdVkoPaDfxKyui/ISO8N+A/b6tgZM6YFrVqAAAAAElFTkSuQmCC"
    })));
};
DollarHeart.displayName = 'DollarHeart';
export default DollarHeart;

//# sourceMappingURL=DollarHeart.js.map